import React from 'react'
import Box from '@material-ui/core/Box'
import ManualDepositForm from '../../../components/admin/manual/ManualDepositForm'
import ManualDepositTable from '../../../components/admin/manual/ManualDepositTable'

const ManualDepositPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <ManualDepositForm />
      </Box>
      <Box paddingTop={3}>
        <ManualDepositTable />
      </Box>
    </Box>
  )
}

export default React.memo(ManualDepositPage)
